import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PreloginService } from '../../services/prelogin.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private router: Router, private activatedRoute: ActivatedRoute, private preLoginService: PreloginService) { }

  errorCode;
  message;
  isError;

  // flag is set to true on button click, and is does not indicates that form has been submitted
  isLoginFormSubmitted = false;

  // Forms
  loginForm: FormGroup;

  isInvalidPassword = false;
  userNotExists = false;
  isErroredOut = false;

  ngOnInit() {
    // redirect already logged in user to dashboard
    if (localStorage.getItem('pp_session') != null) {
      this.router.navigate(['/my-dashboard']);
    }

    this.activatedRoute.queryParams.subscribe(params => {
      if (params.hasOwnProperty('err')) {
        this.errorCode = params.err;
        if (this.errorCode == 403) {
          this.isError = true;
          this.message = 'Session Expired!';
        }
        else if (this.errorCode == 0) {
          this.isError = true;
          this.message = 'Unknown Error!';
        }
      }
    });

    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  // getters
  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }

  // Login Form submit
  loginFormSubmit() {

    this.resetFlags();

    this.isLoginFormSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.preLoginService.login(this.loginForm.value).subscribe(data => {
      if (data.statusCode == 200 && data.status == false) {
        this.isInvalidPassword = data.message;
      }
      else if (data.statusCode == 404 && data.status == false) {
        this.userNotExists = data.message;
      }
      else if (data.statusCode == 500 && data.status == false) {
        this.isErroredOut = data.message;
      }
      else {
        this.router.navigate(['/my-dashboard']);
      }
    });
  }

  resetFlags() {
    this.isInvalidPassword = false;
    this.userNotExists = false;
  }
}
